import axios from "axios";
window.axios = axios;

import _ from "lodash";
window._ = _;

// import Swiper styles
import Rellax from "rellax";
import AOS from "aos";

import Swiper from "swiper/bundle";
window.Swiper = Swiper;

import algoliasearch from "algoliasearch";
window.algoliasearch = algoliasearch;

import ImageZoom from "js-image-zoom";
window.ImageZoom = ImageZoom;

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import Alpine from "alpinejs";
import ui from "@alpinejs/ui";
import mask from "@alpinejs/mask";
import persist from "@alpinejs/persist";
import focus from "@alpinejs/focus";
import collapse from "@alpinejs/collapse";
import intersect from "@alpinejs/intersect";

window.Alpine = Alpine;

Alpine.plugin(ui);
Alpine.plugin(mask);
Alpine.plugin(persist);
Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(intersect);

Alpine.start();

new Rellax(".rellax", {
    // center: true,
    breakpoints: [640, 1024, 1280],
});

AOS.init({
    duration: 1500,
    once: true,
});

// Expanding image mask (Image block "Expand on scroll").
// CSS makes the section 200vh with a sticky inner wrapper; GSAP scrubs the
// frame open and the image zoom out across that scroll distance.
gsap.matchMedia().add("(prefers-reduced-motion: no-preference)", () => {
    document.querySelectorAll(".expand-mask").forEach((section) => {
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: "top top",
                end: "bottom bottom",
                scrub: 0.5,
            },
        });

        timeline
            .fromTo(
                section.querySelector(".expand-mask__sticky"),
                { clipPath: "inset(15% 6% 6%)" },
                { clipPath: "inset(0% 0% 0%)", ease: "none" }
            )
            .fromTo(
                section.querySelector(".expand-mask__image"),
                { scale: 1.15 },
                { scale: 1, ease: "none" },
                0
            );
    });
});

document.addEventListener("DOMContentLoaded", function () {

    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

    if ("IntersectionObserver" in window) {
        var lazyVideoObserver = new IntersectionObserver(function (
            entries,
            observer
        ) {
            entries.forEach(function (video) {
                if (video.isIntersecting) {
                    for (var source in video.target.children) {
                        var videoSource = video.target.children[source];
                        if (
                            typeof videoSource.tagName === "string" &&
                            videoSource.tagName === "SOURCE"
                        ) {
                            videoSource.src = videoSource.dataset.src;
                        }
                    }

                    video.target.load();
                    video.target.classList.remove("lazy");
                    lazyVideoObserver.unobserve(video.target);
                }
            });
        });

        lazyVideos.forEach(function (lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
        });
    }

    let modalLinks = document.querySelectorAll('a[href*="modal"]');

    modalLinks.forEach(function (link) {
        link.addEventListener("click", (e) => {
            const searchParams = new URLSearchParams(link.search);
            if (searchParams.has("modal") && searchParams.get("modal")) {
                e.stopPropagation();
                e.preventDefault();

                let modalName = searchParams.get("modal");

                const openModalEvent = new Event(`open-${modalName}-modal`, {
                    detail: {},
                    bubbles: true,
                    // Allows events to pass the shadow DOM barrier.
                    composed: true,
                    cancelable: true,
                });

                const closeMenuEvent = new Event(`close-menu`, {
                    detail: {},
                    bubbles: true,
                    // Allows events to pass the shadow DOM barrier.
                    composed: true,
                    cancelable: true,
                });

                window.dispatchEvent(closeMenuEvent);
                window.dispatchEvent(openModalEvent);

                return false;
            }
        });
    });
});
